export class Tab {
    constructor() {
        this.param = null;
    }

    init() {


        //INDEX-NEWS
        if (document.getElementById('index-news')) {

            let tabStatus = 0;
            let tabWrapper = document.getElementById('index-news');
            let tabs = tabWrapper.querySelectorAll('.tab-select li');
            let tabContents = tabWrapper.querySelectorAll('.news-content .news-content-group');

            [].forEach.call(tabs, function (elem, index) {
                elem.addEventListener('click', function () {
                    tabStatus = index;
                    tabClicked(elem);
                    //console.log(index);
                });
            });
            let tabClicked = function (cleckedElem) {
                //console.log(cleckedElem);

                // tabの切り替え
                [].forEach.call(tabs, function (elem) {
                    elem.classList.remove('selected');
                });
                cleckedElem.classList.add('selected');

                // contentsの切り替え
                [].forEach.call(tabContents, function (elem) {
                    elem.classList.remove('show');
                });
                tabContents[tabStatus].classList.add('show');
            }
        }


        //CONTACT <input type="radio" name="want-sample"
        if (document.getElementById('want-sample')) {
            let elem = document.getElementById('want-sample');
            var radioBtns = elem.querySelectorAll('input[type=radio]');

            [].forEach.call(radioBtns, function (elem, index) {
                //console.log(elem);
                elem.addEventListener('click', (e) => {
                    //console.log(index);

                    document.getElementById('tab-content-0').classList.remove('selected');
                    document.getElementById('tab-content-1').classList.remove('selected');

                    let targetId = 'tab-content-' + index;
                    document.getElementById(targetId).classList.add('selected');
                });

                // if(elem.checked == true){
                //     let targetId = 'tab-content-' + (index + 1);
                // }
            });
        }
    }

}